export const TOUR_CUSTOMER_DETAILS_API_START = "TOUR_CUSTOMER_DETAILS_API_START";
export const TOUR_CUSTOMER_DETAILS_API_SUCCESS = "TOUR_CUSTOMER_DETAILS_API_SUCCESS";
export const TOUR_CUSTOMER_DETAILS_API_ERROR = "TOUR_CUSTOMER_DETAILS_API_ERROR";

export const TOUR_OPERATOR_TOURS_API_START = "TOUR_OPERATOR_TOURS_API_START";
export const TOUR_OPERATOR_TOURS_API_SUCCESS = "TOUR_OPERATOR_TOURS_API_SUCCESS";
export const TOUR_OPERATOR_TOURS_API_ERROR = "TOUR_OPERATOR_TOURS_API_ERROR";

export const TOUR_OPERATOR_RE_FLEET_START = "TOUR_OPERATOR_RE_FLEET_START";
export const TOUR_OPERATOR_RE_FLEET_SUCCESS = "TOUR_OPERATOR_RE_FLEET_SUCCESS";
export const TOUR_OPERATOR_RE_FLEET_ERROR = "TOUR_OPERATOR_RE_FLEET_ERROR";